module.exports = __webpack_public_path__ + "img/our-client-feedback-img-3.9ec0e1c2.png";